"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FOCUS_NAME_TO_LOCATIONS = exports.FOCUS_NAME_TO_ID = exports.FOCUS_ID_TO_NAME = exports.COLLECTION_FOCUS = void 0;
/**
 * Unified Collection Focus constant mirroring the legacy searchui-resultsui collectionFocusConstant.
 * Maps between numeric IDs (UPS contract), weightGroupName strings (form internal), and location GPIDs.
 */
const COLLECTION_FOCUS = exports.COLLECTION_FOCUS = [{
  id: "0",
  weightGroupName: "default",
  locationGpids: []
}, {
  id: "1",
  weightGroupName: "fromquery",
  locationGpids: []
}, {
  id: "2",
  weightGroupName: "australian",
  locationGpids: ["5027"]
}, {
  id: "3",
  weightGroupName: "canada",
  locationGpids: ["3243"]
}, {
  id: "4",
  weightGroupName: "english",
  locationGpids: ["3257", "3250"]
}, {
  id: "5",
  weightGroupName: "french",
  locationGpids: ["5087"]
}, {
  id: "6",
  weightGroupName: "german",
  locationGpids: ["3253"]
}, {
  id: "7",
  weightGroupName: "italian",
  locationGpids: ["5118"]
}, {
  id: "8",
  weightGroupName: "irish",
  locationGpids: ["3257", "3250"]
}, {
  id: "9",
  weightGroupName: "scottish",
  locationGpids: ["3257", "3250"]
}, {
  id: "10",
  weightGroupName: "swedish",
  locationGpids: ["5216"]
}, {
  id: "11",
  weightGroupName: "united-kingdom",
  locationGpids: ["3257", "3250"]
}, {
  id: "12",
  weightGroupName: "usa",
  locationGpids: ["2"]
}, {
  id: "13",
  weightGroupName: "welsh",
  locationGpids: ["5250"]
}, {
  id: "14",
  weightGroupName: "new-zealand",
  locationGpids: ["5166"]
}, {
  id: "15",
  weightGroupName: "mexico",
  locationGpids: ["3255"]
}, {
  id: "16",
  weightGroupName: "netherlands",
  locationGpids: ["5163"]
}, {
  id: "17",
  weightGroupName: "norway",
  locationGpids: ["5173"]
}, {
  id: "100",
  weightGroupName: "african-american",
  locationGpids: []
}, {
  id: "101",
  weightGroupName: "jewish",
  locationGpids: []
}, {
  id: "102",
  weightGroupName: "native-american",
  locationGpids: []
}];
const FOCUS_NAME_TO_ID = exports.FOCUS_NAME_TO_ID = Object.fromEntries(COLLECTION_FOCUS.map(({
  weightGroupName,
  id
}) => [weightGroupName, id]));
const FOCUS_ID_TO_NAME = exports.FOCUS_ID_TO_NAME = Object.fromEntries(COLLECTION_FOCUS.map(({
  id,
  weightGroupName
}) => [id, weightGroupName]));
const FOCUS_NAME_TO_LOCATIONS = exports.FOCUS_NAME_TO_LOCATIONS = Object.fromEntries(COLLECTION_FOCUS.filter(({
  locationGpids
}) => locationGpids.length > 0).map(({
  weightGroupName,
  locationGpids
}) => [weightGroupName, [...locationGpids]]));